import React, { memo, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Button, ListGroup, Col, Card } from "react-bootstrap";
import DividerLine from "../../../components/examComponents/DividerLine";
import { getAssessmentById } from "../../../utils/assessments";
import Loader from "../../../components/Loader";
import { getUserRole } from "../../../store/userRole";
import { useSelector } from "react-redux";
import RenderLatexContent from "../../../components/RenderLatexContent";
import { useDispatch } from "react-redux";
import { clearFullLengthExamAll } from "../../../store/fullLengthExam";
import FiChevronUp from "../../../constants/icons/Fi/FiChevronUp";
import FiChevronDown from "../../../constants/icons/Fi/FiChevronDown";
import StopFullLengthExamAttempt from "../../../components/Classroom/StopFullLengthExamAttempt";
import "./examDetails.scss";
import {setExamData} from "../../../store/examSlice";

function ExamDetails({ isMobileView }) {
  const { examId, classroomId } = useParams();
  const roleOfTheUser = useSelector(getUserRole);
  const [assessment, setAssessment] = useState(null);
  const [stopStart, setStopStart] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isTabScreen, setIsTabScreen] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsTabScreen(window.innerWidth >= 768); // 768px is a common tablet+ threshold
      setIsMobileScreen(window.innerWidth < 768);
    };

    checkScreenSize(); // initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  useEffect(() => {
    const fetchAssessment = async () => {
      try {
        const response = await getAssessmentById(examId);
        if (response.assessment) {
          setAssessment(response.assessment);
        } else {
          console.error("Error fetching assessment details:", response.error);
        }
      } catch (error) {
        console.error("Error fetching assessment details:", error.message);
      }
    };

    fetchAssessment();
  }, [examId]);

  if (!assessment) {
    return <Loader />; // You can add a spinner or loading indicator here
  }

  const handleStartClick = (examId) => {
    navigate(
      `${
        roleOfTheUser === "Student" ? "/student" : ""
      }/${classroomId}/exams/${examId}`
    );
  };

  return (
    <div>
      <Header title={assessment.name} />
      {stopStart && (
        <StopFullLengthExamAttempt
          open={stopStart}
          onClose={() => setStopStart(!stopStart)}
          title={"Exam Device Advisory"}
          message={
            "Please attempt the full-length exam on a laptop for an optimal experience. Mobile devices are not recommended."
          }
        />
      )}
      <Container className="d-flex justify-content-center exam-details-container" style={{paddingTop:"87px"}}>
        <Col xs={12} sm={10} md={8} lg={6} className="exam-details-col">
          <div className="d-flex justify-content-between align-items-center mb-2 exam-details-header-row">
            <h6>Sections</h6>
            <Button
              style={{ backgroundColor: "green" }}
              size="lg"
              block
              className="start-test-btn"
              onClick={() => {
                if (isMobileScreen) {
                  setStopStart(true);
                } else {
                  handleStartClick(assessment._id);
                  dispatch(setExamData(null))
                  dispatch(clearFullLengthExamAll());
                }
              }}
            >
              Start Test
            </Button>
          </div>
          <ListGroup className="exam-details-section-list">
            {assessment.sections.map((section, index) => (
              <TestSection
                key={index}
                title={section.name}
                time={formatTime(section.duration * 60)}
                instructions={section?.instructions}
              />
            ))}
          </ListGroup>
          <Instructions instructions={assessment.instructions} />
        </Col>
      </Container>
      <Footer />
    </div>
  );
}

const Header = ({ title }) => {
  return (
    <div
      className="exam-details-header"
      style={{
        top: 0,
        left: 0,
        right: 0,
        position: "fixed",
        backgroundColor: "#e6edf8",
        zIndex: 1,
      }}
    >
      <header className="m-3">
        <h4>{title}</h4>
      </header>
      <DividerLine />
    </div>
  );
};

const TestSection = ({ title, time, instructions }) => {
  const [isExpand, setIsExpand] = useState(false);
  const toggleExpand = () => {
    setIsExpand(!isExpand);
  };
  return (
    <ListGroup.Item>
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className="d-flex align-items-center">
            {isExpand ? (
              <FiChevronUp
                size={25}
                onClick={toggleExpand}
                style={{ marginRight: "8px", cursor: "pointer" }}
              />
            ) : (
              <FiChevronDown
                size={25}
                onClick={toggleExpand}
                style={{ marginRight: "8px", cursor: "pointer" }}
              />
            )}
            {title}
          </div>
          <div
            style={{ height: "25px", display: "flex", alignItems: "center" }}
          >
            {time}
          </div>
        </div>
      </div>

      {isExpand && (
        <div className="mt-3">
          <div style={{ fontSize: "16px", fontWeight: 700 }}>Instructions</div>
          <RenderLatexContent content={instructions} />
        </div>
      )}
    </ListGroup.Item>
  );
};

const Instructions = ({ instructions }) => {
  return (
    <Card className="mt-4">
      <Card.Body>
        <div>Instructions</div>
        <RenderLatexContent content={instructions} />
      </Card.Body>
    </Card>
  );
};

const Footer = () => {
  return (
    <div
      className="exam-details-footer"
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        height: "60px",
        backgroundColor: "#e6edf8",
        zIndex: 1,
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <DividerLine />
      </div>
    </div>
  );
};

const formatTime = (duration) => {
  const minutes = Math.floor(duration / 60);
  const seconds = duration % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
};

export default memo(ExamDetails);
